module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingReceiverForm"
    }
  }, [_c('h1', {
    staticClass: "header"
  }, [_vm._v("授業振替依頼を承認／不承認する")]), _vm._v(" "), (!_vm.reschedulingInfo) ? _c('div', {
    key: "not-found"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(1)]) : (_vm.reschedulingInfo.status != 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(2)]) : (!_vm.checkExpireDate) ? _c('div', {
    key: "expiration"
  }, [_vm._m(3)]) : _c('div', {
    key: "receiver-form"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "が以下の授業振替を依頼されています")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("対象の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -3)))])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替希望理由")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reason.split('\n')), function(row) {
    return _c('p', {
      key: "reason-row",
      staticClass: "info-content reason-row"
    }, [_vm._v("\n          " + _vm._s(row) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替を"), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("承認")]), _vm._v("する場合は"), _c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("候補日時のうちの1つを選択")]), _vm._v("してください")], 1), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替を"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("不承認")]), _vm._v("する場合は"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("「振替を不承認する」にチェック")]), _vm._v("してください")], 1), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isSelectionCompleted) ? _c('notificationBox', {
    key: "warning-selection",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "候補日時のうち1つを選択するか、「振替を不承認する」にチェックしてください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isSelectionCompleted) ? _c('notificationBox', {
    key: "ok-selection",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDenying),
      expression: "isDenying"
    }],
    attrs: {
      "id": "denying-checkbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDenying) ? _vm._i(_vm.isDenying, null) > -1 : (_vm.isDenying)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDenying,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDenying = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDenying = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDenying = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "denying-checkbox"
    }
  }, [_vm._v("振替を不承認する")])]), _vm._v(" "), (!_vm.isDenying) ? _c('div', {
    key: "select-datetime-area",
    attrs: {
      "id": "select-datetime-area"
    }
  }, [_c('div', {
    staticClass: "info",
    class: {
      'info-inline-block': !_vm.isNarrowMode
    }
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("元の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('p', [_vm._v("日付：　" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：　" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -3)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -3)))])])]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-back",
    class: {
      'right-arrow': !_vm.isNarrowMode, 'down-arrow': _vm.isNarrowMode
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info",
    class: {
      'info-inline-block': !_vm.isNarrowMode
    }
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("候補日時")]), _vm._v(" "), _c('ul', {
    staticClass: "info-content",
    class: {
      'narrow-list': !_vm.isNarrowMode
    },
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.candidate_datetimes), function(candidate, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item-candidate-index"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCandidate),
        expression: "selectedCandidate"
      }],
      attrs: {
        "id": 'list-item-candidate-radio' + index,
        "type": "radio",
        "disabled": _vm.isDenying
      },
      domProps: {
        "value": candidate,
        "checked": _vm._q(_vm.selectedCandidate, candidate)
      },
      on: {
        "change": [function($event) {
          _vm.selectedCandidate = candidate
        }, function($event) {
          _vm.selectedCandidateChanged()
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'list-item-candidate-radio' + index
      }
    }, [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-content"
    }, [_c('p', [_vm._v("日付：" + _vm._s(_vm.formattedDate(candidate.date)))]), _vm._v(" "), _c('p', [_vm._v("時間：" + _vm._s(candidate.start_time) + " 〜 " + _vm._s(candidate.end_time) + _vm._s(candidate.mode === 'slot' ? 'の1コマ' : 'の中で' + candidate.duration + '分間'))])])])
  }))])]) : _vm._e()], 1), _vm._v(" "), (!_vm.isDenying && _vm.selectedCandidate && _vm.selectedCandidate.mode === 'range') ? _c('section', {
    key: "timeslot",
    staticClass: "section"
  }, [_c('div', [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.selectedCandidate.start_time) + " 〜 " + _vm._s(_vm.selectedCandidate.end_time) + "の中で" + _vm._s(_vm.selectedCandidate.duration) + "分間、都合の良い時間帯を1つ選んでください")]), _vm._v(" "), _c('p', [_vm._v("（開始時刻か終了時刻のどちらかを指定すると、自動的にもう一方も指定されます）")]), _vm._v(" "), (_vm.isCompletenessChecking && !_vm.isTimeslotCompleted) ? _c('notificationBox', {
    key: "warning-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "開始時刻と終了時刻を選択してください"
    }
  }) : (_vm.isCompletenessChecking && _vm.isTimeslotCompleted) ? _c('notificationBox', {
    key: "ok-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "開始時刻を選択",
      "picker-options": {
        start: _vm.selectedCandidate.start_time,
        end: _vm.selectedCandidate.end_time,
        step: '00:05',
        maxTime: _vm.moment(_vm.selectedCandidate.end_time, 'HH:mm').add(-_vm.selectedCandidate.duration + 1, 'minutes').format('HH:mm')
      }
    },
    on: {
      "change": function($event) {
        _vm.timeslotStartTimeChanged()
      }
    },
    model: {
      value: (_vm.timeslot.start_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "start_time", $$v)
      },
      expression: "timeslot.start_time"
    }
  }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "終了時刻を選択",
      "picker-options": {
        start: _vm.selectedCandidate.start_time,
        end: _vm.selectedCandidate.end_time,
        step: '00:05',
        minTime: _vm.moment(_vm.selectedCandidate.start_time, 'HH:mm').add(_vm.selectedCandidate.duration - 1, 'minutes').format('HH:mm')
      }
    },
    on: {
      "change": function($event) {
        _vm.timeslotEndTimeChanged()
      }
    },
    model: {
      value: (_vm.timeslot.end_time),
      callback: function($$v) {
        _vm.$set(_vm.timeslot, "end_time", $$v)
      },
      expression: "timeslot.end_time"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("不承認の場合、他の候補日時を複数記入してください。")]), _vm._v(" "), (!_vm.isAlternativeDatetimes && _vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "warning-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "warning",
      "text": "開始時刻と終了時刻を選択してください"
    }
  }) : (_vm.isAlternativeDatetimes && _vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "ok-timeslot",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: "candidate-list"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.alternative_datetimes), function(cand, index) {
    return _c('li', {
      key: 'list-item-candidate' + index,
      staticClass: "list-item list-item-candidate"
    }, [_c('div', {
      staticClass: "candidate-box"
    }, [_c('div', {
      staticClass: "candidate-caption"
    }, [_c('div', {
      staticClass: "candidate-caption-label"
    }, [_c('label', [_vm._v("候補 " + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "candidate-caption-button"
    }, [_c('el-button', {
      staticClass: "btn",
      style: ({
        visibility: (_vm.alternative_datetimes.length > 1) ? 'visible' : 'hidden'
      }),
      attrs: {
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          _vm.deleteCandidate(index)
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('label', [_vm._v("日付：")]), _vm._v(" "), _c('el-date-picker', {
      staticStyle: {
        "width": "190px"
      },
      attrs: {
        "placeholder": "日付を選択",
        "format": 'yyyy年MM月dd日(' + _vm.getWeekday(new Date(cand.date)) + ')',
        "value-format": "yyyy-MM-dd",
        "picker-options": {
          disabledDate: _vm.disabledDate
        }
      },
      model: {
        value: (cand.date),
        callback: function($$v) {
          _vm.$set(cand, "date", $$v)
        },
        expression: "cand.date"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('label', [_vm._v("時間：")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-slot-mode' + index,
        "type": "radio",
        "value": "slot"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "slot")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "slot")
        }, function($event) {
          cand.start_time = null;
          cand.end_time = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-slot-mode' + index
      }
    }, [_vm._v("1コマ分を指定")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cand.mode),
        expression: "cand.mode"
      }],
      attrs: {
        "id": 'radio-range-mode' + index,
        "type": "radio",
        "value": "range"
      },
      domProps: {
        "checked": _vm._q(cand.mode, "range")
      },
      on: {
        "change": [function($event) {
          _vm.$set(cand, "mode", "range")
        }, function($event) {
          cand.start_time = null;
          cand.end_time = null
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'radio-range-mode' + index
      }
    }, [_vm._v("範囲で指定")])]), _vm._v(" "), _c('div', {
      staticClass: "alternative-content"
    }, [_c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "開始時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          maxTime: _vm.getMaxStartTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateStartTimeChanged(cand)
        }
      },
      model: {
        value: (cand.start_time),
        callback: function($$v) {
          _vm.$set(cand, "start_time", $$v)
        },
        expression: "cand.start_time"
      }
    }), _vm._v(" "), _c('label', [_vm._v(" 〜 ")]), _vm._v(" "), _c('el-time-select', {
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "placeholder": "終了時刻を選択",
        "picker-options": {
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: _vm.getMinEndTime(cand)
        }
      },
      on: {
        "change": function($event) {
          _vm.candidateEndTimeChanged(cand)
        }
      },
      model: {
        value: (cand.end_time),
        callback: function($$v) {
          _vm.$set(cand, "end_time", $$v)
        },
        expression: "cand.end_time"
      }
    }), _vm._v(" "), (cand.mode === 'slot') ? _c('label', {
      key: "slot-mode"
    }, [_vm._v("\n                  の1コマ\n                ")]) : (cand.mode === 'range') ? _c('label', {
      key: "range-mode"
    }, [_vm._v("\n                  の中で" + _vm._s(_vm.reservationDuration) + "分間\n                ")]) : _vm._e()], 1)])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.addEmptyCandidate()
      }
    }
  }, [_vm._v("\n          ＋ 候補日時を追加する\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? _c('section', {
    key: "option-section",
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替後の授業の情報を指定してください")]), _vm._v(" "), (_vm.isCompletenessChecking) ? _c('notificationBox', {
    key: "ok-reservation-option",
    staticClass: "notificationBox",
    attrs: {
      "type": "ok",
      "text": "正しく入力されています"
    }
  }) : _vm._e(), _vm._v(" "), _c('reschedulingOptionForm', {
    attrs: {
      "reservationOption": _vm.reservationOption
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDenying) ? _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.onConfirmButtonClicked()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.commitMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isDenying) ? _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.denyButtonClicked()
      }
    }
  }, [_vm._v("\n      確認画面に進む\n    ")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報が見つかりません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報の承認期限が過ぎております")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-aed3b6ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aed3b6ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingReceiverForm.vue
// module id = 744
// module chunks = 0